'use client';

import type { ReactNode } from 'react';
import { Box, VStack } from '@terra/ui-styled-system';

export type ListPageLayoutProps = {
  header?: ReactNode;
  tabs?: ReactNode;
  navigation?: ReactNode;
  filters?: ReactNode;
  children: ReactNode;
};

export function ListPageLayout({
  header,
  tabs,
  navigation,
  filters,
  children,
}: ListPageLayoutProps) {
  return (
    <VStack
      w="full"
      h="full"
      gap="0"
      alignItems="stretch"
      overflow="hidden"
      bg="bg.canvas"
    >
      <VStack gap="3" alignItems="stretch" px="6" py="6" flexShrink={0}>
        {header}
        {tabs}
        {navigation}
        {filters}
      </VStack>
      <Box
        flex="1"
        minH="0"
        px="6"
        display="flex"
        flexDirection="column"
        overflow="hidden"
      >
        {children}
      </Box>
    </VStack>
  );
}
